<script>
import Base from '@backend/Base.vue';
import BoConfig from '@config/BoConfig.js';
import BOGen from '@helper/BOGen.js';

export default {
  extends: Base,
  data(){
    return {
      Name:"MovementInit",
      PageName: "Movement Initiation",
      ObjectName: "Movement Initiation",
      AddItem: true,
      input: {},
      emp: {},
      selWL: {},
      selCity: {},
      optDepartment : [],
      mrValidation:{
        ai_mjt_id: "required",
        ai_mrf_id : "required",
        ai_cwid_from : "required",
        ai_cwid : "required",
        ai_ipin : "required",
        ai_bg_id : "required",
        ai_msg_id : "required",
        ai_cc_id : "required",
        ai_mwl_id : "required",
        ai_wl_province : "required",
        ai_wl_city : "required",
        ai_request_date : "required",
        ai_remarks : "required",
        ai_superior: "required",
        ai_effective_join_date: "required",
        // ai_encrypt_key : "required",
      },
    }
  },
  computed:{
    mrRelocationArea(){ return BoConfig.mrRelocationArea },
    mrCostCenterChain(){ 
      if(!this.row.ai_msg_id) return []
      return this.mrCostCenter.filter((x)=>{ return x.mcc_msg_id == this.row.ai_msg_id })
    }
  },
  mounted(){
    this.checkMenuMovement()
    this.$set(this.$root, 'page', this)
    if(this.$route.params.id){
      this.refreshData()
    }
    BOGen.apirest("/department-select", "", (err, resp)=>{
      this.optDepartment = resp.data
    })
  },
  methods:{
    changeDepartment(){
      let indx = this.optDepartment.findIndex(x=>x.msg_id == this.input.ai_msg_id)
      if(this.input.ai_msg_id){
        let rowcheck = this.optDepartment[indx]
        if(!rowcheck.msg_manager){
          swal("This department does not have a Dept. Head", "", "error").then(()=>{
          })
        }
      }
    },
    refreshData(cwid = null){
      this.loadingOverlay = true
      var params = {request_number:this.$route.params.id}
      if(cwid) params = {cwid:cwid}
      BOGen.apirest("/WorkingFacility", params, (err, resp)=>{
        this.loadingOverlay = false
        if(err) return console.error(err);
        Object.keys(resp).forEach((k)=>{
          this[k] = Gen.clone(resp[k])
        })
        if(cwid){
          Object.keys(this.emp).forEach((k)=>{
            if(["cwid","end_fathering_period","effective_end_date","end_contract_date"].indexOf(k)>-1) return;
            this.$set(this.input, "ai_"+k, Gen.clone(this.emp[k]))
          })
          this.$set(this.input, 'ai_direct_report_manager', resp.emp.manager)          
          
          if(this.input.ai_mrf_id == 13){
            this.input.ai_msg_id = resp.emp.msg_id;
          } else {
            this.input.ai_msg_id = "";
          }
          this.input.ai_mjt_id = "";
          this.input.ai_cc_id = "";
          this.input.ai_cc_costcenter = "";
          
          
          this.input.ai_remarks = ""
          this.input.ai_old_bg_id = this.emp.bg_id
          this.input.ai_old_division = this.emp.division
          this.input.ai_old_msg_id = this.emp.msg_id
          this.input.ai_old_departement = this.emp.department
          this.input.ai_old_cc_id = this.emp.cc_id
          this.input.ai_old_costcenter = this.emp.costcenter
          this.input.ai_old_mjt_id = this.emp.mjt_id
          this.input.ai_old_job_title = this.emp.jobtitle

          delete this.input.ai_id
        }else{
          this.input = Gen.clone(this.row)
          setTimeout(()=>{
            this.input.ai_msg_id = resp.row.ai_msg_id;
            this.input.ai_wl_city = resp.row.ai_wl_city;
          }, 300)
          setTimeout(()=>{
            this.input.ai_cc_id = resp.row.ai_cc_id;
            this.input.ai_costcenter = resp.row.costcenter;
          }, 500)
          this.input.ai_remarks = ""
        }
      }, "POST")
    },
    resultDataEmployee(data) {
      var items = [];
      data.data.forEach((x)=>{
        items.push({
          id: x.cwid,
          text: (x.cwid?x.cwid+" | ":"")+x.employeename,
        })
      })
      return {results: items}
    },
    resultDataSuperior(data) {
      var items = [];
      data.data.forEach((x)=>{
        items.push({
          id: x.cwid,
          text: (x.cwid?x.cwid+" | ":"")+x.employeename,
        })
      })
      return {results: items}
    },
    submitForm(e){
      let indx = this.optDepartment.findIndex(x=>x.msg_id == this.input.ai_msg_id)
      let rowcheck = this.optDepartment[indx]
      if(!rowcheck.msg_manager){
        return swal("This department does not have a Dept. Head", "", "error").then(()=>{
        })
      }

      swal({
        title: "Are you sure to submit?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if(!ok) return;
        if(e.btnLoading()) return;
        var input = Gen.clone(this.input)
        Object.keys(input).forEach((k)=>{
          if(!input[k]) delete input[k]
        })
        if(!input.ai_cwid) input.ai_cwid = input.ai_cwid_from
         const effectiveJoinDate = new Date(input.ai_effective_join_date.split("-").reverse().join(","))
         effectiveJoinDate.setDate(effectiveJoinDate.getDate() + 1)
         
         input.ai_effective_join_date = effectiveJoinDate

        /* delete null date */
        BOGen.apirest("/MovementInit", input, (err, resp)=>{
          e.btnUnloading()
          // if(err) return console.error(err)
          swal("Data has been submitted", "", "success").then(()=>{
            this.$router.push({name:"MovementList"})
            this.input = {}
            $("body,html").animate({scrollTop:0}, 300)
          })
        },"POST")
      })
    },
    checkMenuMovement(){
      const menu = this.user.al_access_menu

      if(menu.indexOf("MovementList") < 0){
        return this.$router.push({name:"Dashboard"})
      }
    },
  },
  watch:{
    '$route.query'(){ this.refreshData() },
    'input.ai_mrf_id'(v){
      if(!this.input.ai_id){
        this.$set(this.input, 'ai_cwid_from', '');
        this.emp = {}
        this.input = {ai_mrf_id:v}
      }
    },
    'input.ai_wl_city'(v){ if(v){ this.$set(this.row, 'other_wl_city', "") } },
    'input.ai_cwid_from'(v){
      if(!v||this.$route.params.id) return;
      this.refreshData(v)
    },
  }
}
</script>

<template>
  <div class="container-fluid">
    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{PageName}}</h4>
      </div>
      <div class="col-md-7 tr">
        <div class="btn-group">
          <router-link :to="{name:'MovementList'}" class="btn btn-outline-info" v-tooltip="'List Movement'">
            <i class="fa fa-list"></i><span> List</span>
          </router-link>
        </div>
      </div>
    </div>

    <VForm @resp="submitForm" method="post">
      <div class="card">
        <div class="card-body card-form">
          <h4 class="card-title">{{ObjectName}} Form</h4>
        </div>
        <div class="card-header bg-info">
          <h4 class="m-b-0 text-white">Authorization</h4>
        </div>
        <div class="card-body">
          <div class="info"></div>
          <div class="row mb15" v-if="$route.params.id">
            <div class="col-sm-2">
              <b>Remarks :</b>
            </div>
            <div class="col-sm-10">
              <b>{{ (row.aal||{}).aal_remarks }}</b>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <BoField name="ai_request_date">
                {{ moment().format("YYYY-MM-DD HH:mm:ss").dates("format2") }}
              </BoField>
            </div>
            <div class="col-sm-4">
              <BoField name="ai_mrf_id">
                <Select2 name="ai_mrf_id" url="/request-for-select?type=movement" :object="['mrf_id','mrf_name']" v-model="input.ai_mrf_id" v-bind="validation('ai_mrf_id')" :disabled="$route.params.id">
                  <option value="">-- Select Request For --</option>
                </Select2>
              </BoField>
            </div>
            <div class="col-sm-3" v-if="input.ai_mrf_id">
              <BoField name="ai_cwid_from">
                <Select2Ajax :url="'/api/employees-select?havecwid=true&msg_id='+user.emp.msg_id+'&isAdmin='+(user.emp.access_level==1?true:false)+'&user='+user.emp.cwid+'&type=movement'" name="ai_cwid_from" v-model="input.ai_cwid_from" v-bind="validation('ai_cwid_from')" :resultData="resultDataEmployee" placeholder="-- Select Employee --" :disabled="$route.params.id"></Select2Ajax>
              </BoField>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <BoField label="IPIN">
                <input class="form-control" :value="emp.IPIN ? emp.IPIN : '-'" disabled>
              </BoField>
            </div>
            <div class="col-sm-3">
              <BoField label="Division">
                <input class="form-control" :value="'Cimanggis Plant'" disabled>
              </BoField>
            </div>
            <div class="col-sm-3">
              <BoField :label="'Old '+fields.ai_msg_id">
                <input class="form-control" :value="emp.department" disabled>
              </BoField>
            </div>
            <div class="col-sm-3">
              <BoField name="ai_msg_id">
                <Select2 :options="optDepartment" :filter="'x.msg_bg_id=='+input.ai_bg_id" :object="['msg_id','msg_name']" name="ai_msg_id" v-model="input.ai_msg_id" :disabled="input.ai_mrf_id==13?true:false" v-bind="validation('ai_msg_id')" @input="changeDepartment">
                  <option value="">-- Select Department --</option>
                </Select2>
              </BoField>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <BoField :label="'Old '+fields.ai_mjt_id">
                <input class="form-control" :value="emp.position" disabled>
              </BoField>
            </div>
            <div class="col-sm-3">
              <BoField name="ai_mjt_id">
                <Select2 name="ai_mjt_id" url="/job-title-select" :object="['mjt_id','mjt_name']" v-model="input.ai_mjt_id" v-bind="validation('ai_mjt_id')">
                  <option value="">-- Select Position Title --</option>
                </Select2>
              </BoField>
            </div>

            <div class="col-sm-3">
              <BoField :label="'Old '+fields.ai_cc_id">
                <input class="form-control" :value="emp.costcenter" disabled>
              </BoField>
            </div>
            <div class="col-sm-3">
              <BoField name="ai_cc_id">
                <Select2 name="ai_cc_id" :url="'/costcenter-select?mjt_id='+input.ai_mjt_id" :object="['mcc_id','mcc_costcenter']" v-model="input.ai_cc_id" v-bind="validation('ai_cc_id')">
                  <option value="">-- Select Cost Center --</option>
                </Select2>
              </BoField>
            </div>

            <!-- Superior -->
            <template v-if="input.ai_msg_id">
              <div class="col-sm-3">
                <BoField :label="'Old '+fields.ai_superior">
                  <input class="form-control" :value="emp.manager ? emp.manager + ' | ' + emp.report_manager : '-'" disabled>
                </BoField>
              </div>
              <div class="col-sm-3">
                <BoField name="ai_superior">
                  <Select2 name="ai_superior" :url="'/superior-select?msg_id='+input.ai_msg_id" :object="['cwid', 'label']" v-model="input.ai_superior" v-bind="validation('ai_superior')">
                    <option value="">-- Select Superior --</option>
                  </Select2>
                </BoField>
              </div>
              <div class="col-md-3">
                <b>Effective Join Date Date <span class="text-danger">*</span></b>
                <div class="mt-2">
                  <DatePicker
                    name="ai_effective_join_date"
                    v-model="input.ai_effective_join_date"
                    v-bind="validation('ai_effective_join_date')"
                    :disabledYesterday="true"
                  ></DatePicker>
                </div>
              </div>
              <div class="col-md-3"></div>
            </template>
            <div class="col-md-4">
              <bo-field name="remarks" label="Remarks" mandatory>
                <textarea name="remarks" v-model="input.ai_remarks" id="remarks" rows="3" class="form-control"
                v-bind="validation('ai_remarks')" ></textarea>
              </bo-field>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="text-right">
            <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit Initiation <i class="icon-arrow-right14 position-right"></i></button>
          </div>
        </div>
      </div>
    </VForm>
  </div>
</template>
